import languages from '../languages';
import {
  getJSON,
  getHrefParam,
  PASSPORT_HOST,
  ACTIVITY_HOST,
  HOME_HOST
} from '../ultile';
const CONFIG_ACTION = 'center/feature_status';
export const GET_CONFIG = 'getConfig';
export const GET_SERIAL_EXCHANGE = 'get_serial_exchange';
export const GET_GAME = 'getGame';
export const GET_EXE_CLIENT_PAY = 'micro_game/dir_login';
const SET_CONFIG = 'setConfig';
const SET_OPEN_EXCHANGE = 'setOpenExchange';
const SET_UNBING_STATE = 'setUnBindState';
const CONFIG_CODE = 1;
languages.init();

export default {
  state: {
    languages: languages.mapMutiples([
      'feedback',
      'feedbackTips',
      'cancel',
      'confirm',
      'switch',
      'bind',
      'terms',
      'tips',
      'bindTps',
      'accountSetting',
      'upgrade',
      'profile',
      'bindEmail',
      'changePassword',
      'securityQuestion',
      'and',
      'haveAgree',
      'termsOfUse',
      'privacyPolicy',
      'accountName',
      'password',
      'newPwd',
      'repeatPassword',
      'completeness',
      'completeTips',
      'realName',
      'gender',
      'male',
      'female',
      'birthday',
      'phone',
      'region',
      'ID',
      'bindEmailTips',
      'enterEmail',
      'enterEmailTips',
      'enterEmailVrfcationTips',
      'originPwd',
      'securityQuestionTips',
      'slectQuessionTips',
      'submit',
      'send',
      'answerTips',
      'changePwdSuccess',
      'modify',
      'rebindEmail',
      'bindEmailSuccess',
      'reSetSecurityQuessoon',
      'guestSwitchTips',
      'canotModifyTips',
      'rebindEmailTips',
      'reGetVrfCode',
      'findPwd',
      'findPwdTips',
      'editVrfCodeTips',
      'findPwdWayTips',
      'emailWay',
      'emailWayTips',
      'quessionWay',
      'quessionWayTips',
      'resetPwdBtn',
      'lastStep',
      'validateQuessionTips',
      'sendEmailTips',
      'setNewPwdTips',
      'findPwdFailTips',
      'exchange',
      'countryCode',
      'deleteaccount_title2',
      'deleteaccount_step1_1',
      'deleteaccount_step1_2',
      'deleteaccount_step1_3',
      'deleteaccount_step1_4',
      'deleteaccount_step2_1',
      'deleteaccount_step2_2',
      'deleteaccount_step3',
      'deleteaccount_step3_1',
      'deleteaccount_step3_2',
      'applyForAccountFix',
      'applyFixAccount',
      'findPwdByFixAccount',
      'accountFix',
      'SwitchWithThirdWay',
      'account_czsm1',
      'account_czsm2',
      'account_czsm3',
      'account_wzfdmm',
      'account_qzcsrmm',
      'account_fxyjm',
      'account_yjmsm1',
      'account_yjmsm2',
      'account_yjmsm3',
      'account_yjmsm4',
      'account_fz',
      'account_cxfx',
      'account_czsm4',
      'account_czsm5',
      'account_yjm',
      'account_yj',
      'login',
      'account_syyjm',
      'account_yjmznsyyc',
      'account_sryjm',
      'account_srmm',
      'account_delete_scdqzh',
      'account_delete_fwq',
      'account_delete_zhm',
      'account_delete_jshflj',
      'account_delete_qzyzmdxx',
      'account_delete_jtbcysxx',
      'contactService',
      'questionnaire_btn',
      'debindTips',
      'debindText',
      'onestore_subscribe_entrance',
      'apple_deleteaccount',
      'apple_deleteaccount_title',
      'apple_deleteaccount_step1_1',
      'apple_deleteaccount_step1_2',
      'apple_deleteaccount_step1_3',
      'apple_deleteaccount_step1_4',
      'apple_deleteaccount_step1_5',
      'apple_deleteaccount_step1_6',
      'apple_deleteaccount_step2_1',
      'apple_deleteaccount_step2_2',
      'apple_deleteaccount_step2_3',
      'apple_deleteaccount_step3_1',
      'apple_deleteaccount_step3_2',
      'apple_deleteaccount_step3_3',
      'apple_deleteaccount_step4_1',
      'apple_deleteaccount_agree',
      'apple_deleteaccount_server',
      'apple_deleteaccount_roleName',
      'copyLink',
      'copyTextAndImg',
      'copyLinkAndRoleInfo',
      'hasCopy',
      'close',
      'new_apple_deleteaccount_stepsub_title',
      'new_apple_deleteaccount_stepsub_1',
      'new_apple_deleteaccount_stepsub_2',
      'new_apple_deleteaccount_stepsub_later',
      'new_apple_deleteaccount_stepsub_now',
      'new_apple_deleteaccount_title',
      'new_apple_deleteaccount_step1_1',
      'new_apple_deleteaccount_step1_2',
      'new_apple_deleteaccount_step1_3',
      'new_apple_deleteaccount_step1_4',
      'new_apple_deleteaccount_step2_1',
      'new_apple_deleteaccount_step2_2',
      'new_apple_deleteaccount_step2_3',
      'new_apple_deleteaccount_step3_1',
      'new_apple_deleteaccount_step3_2',
      'new_apple_deleteaccount_step4_1',
      'tokenLogin',
      'officialPay',
      'changeAccount',
      'nextStep',
      'getReward',
      'unbindEntry',
      'unbindApply',
      'unbindConfirmTitle',
      'unbindConfirmTip',
      'unbindConfirm',
      'unbindExit',
      'unbindSucc',
      'unbindFail',
      'unbindServiceTitle',
      'unbindContact',
      'unbindServiceTip',
      'passAskMods',
      'passAskModsTip',
      'passService',
      'passServiceTip',
      'passIKonw',
      'passGoOn',
      'enterEmailTips',
      'editVrfCodeTips',
      'canRebind',
      'sendGameNews',
      'reGetVrfCode',
      'reGetVrfCode',
      'back',
      'confirm',
      'agreePlatform',
      'emailAccount',
      'phoneAccount',
      'canNotBindEmail',
      'canNotBindPhone',
      'canChangeByEmail',
      'canChangeByPhone',
      'bindCommon',
      'newVipLogin',
      'emailHadBind',
      'phoneHadBind',
      'emailNotBind',
      'phoneNotBind',
      'newVipLogin',
      'registerNewAccount',
      'emailVAlidateMsg',
      'phoneInputError',
      'frequently',
      'inputCkCode',
      'unbindSucc',
      'unbindFail',
      'eventSuccBind',
      'loginSucc',
      'dmaTitle',
      'pwsInstall',
      'riskTipTitle',
      'riskTipContent'
    ]),
    hasRewardFunction: false,
    hasMigrateFunction: false,
    openExchange: false,
    unBindState: false,
    hasAccountDelete: false // 是否显示删除账号入口
  },
  getters: {
    getExchangeState: state => state.openExchange
  },
  mutations: {
    [SET_CONFIG](state, config) {
      state.hasMigrateFunction = config.MIGRATE_CODE == CONFIG_CODE;
      state.hasRewardFunction = config.REWARD == CONFIG_CODE;
      state.hasAccountDelete = config.DESTROY_USER == CONFIG_CODE;
      let gameId = getHrefParam('gameId');
      let configStore = {
        [gameId]: {
          hasMigrateFunction: state.hasMigrateFunction,
          hasRewardFunction: state.hasRewardFunction
        }
      };
      localStorage.setItem('functionConfig', JSON.stringify(configStore));
    },
    [SET_OPEN_EXCHANGE](state, payload) {
      state.openExchange = payload;
    },
    [SET_UNBING_STATE](state, res) {
      state.unBindState = res;
    }
  },
  actions: {
    [GET_CONFIG]({ commit }) {
      getJSON(PASSPORT_HOST + CONFIG_ACTION, {
        gameId: getHrefParam('gameId'),
        packageName: getHrefParam('packageName'),
        packageVersion: getHrefParam('packageVersion'),
        devicePlate: getHrefParam('devicePlate'),
        userMode: getHrefParam('userMode'),
        language: getHrefParam('appLanguage') || getHrefParam('language') || ''
      }).then(({ errmsg, data }) => {
        if (!errmsg) {
          commit(SET_CONFIG, data);
        }
      });
    },
    [GET_SERIAL_EXCHANGE]({ commit }) {
      const packageName = getHrefParam('packageName');
      const link =
        ACTIVITY_HOST +
        `serial_exchange/app_reward_state?app_package_name=${packageName}`;
      return new Promise(resolve => {
        getJSON(link, {}).then(({ errmsg, res }) => {
          if (+res.result === 1) {
            commit(SET_OPEN_EXCHANGE, +res?.data?.REWARD_STATE);
          } else {
            commit(SET_OPEN_EXCHANGE, false);
          }
          resolve();
        });
      });
    },
    [GET_GAME]({ commit }) {
      getJSON(HOME_HOST + `ajax/get_game`, {
        gameID: getHrefParam('gameId')
      }).then(({ errmsg, res }) => {
        if (res.result == 1) {
          commit(SET_UNBING_STATE, +res.data.extra_info.ALLOW_UNBIND);
        }
      });
    }
  }
};
